<template>
  <div>
    <BlockTitle title="数据概况"/>

    <div class="overview-list">
      <DataItem :num="statisData.listingCnt-0" :unit="(statisData.listingCntUnit || '')+'宗'" label="挂牌项目"/>
      <DataItem :num="statisData.listingPrice-0" :unit="(statisData.listingPriceUnit || '')+'元'" label="挂牌金额"/>
      <DataItem :num="statisData.vol-0" :unit="(statisData.volUnit || '')+'宗'" label="成交项目"/>
      <DataItem :num="statisData.gmv-0" :unit="(statisData.gmvUnit || '')+'元'" label="成交金额"/>

    </div>

  </div>
</template>

<script>
import BlockTitle from '@/views/public_0983cc/tradeData/components/public/BlockTitle.vue'
import DataItem from './components/DataItem.vue'
import {mapGetters} from 'vuex'
export default {

  components:{
    BlockTitle,
    DataItem
  },
  computed:{
    ...mapGetters(['statisData','selectLocId'])
  },
  watch:{

  }
}
</script>

<style lang="scss" scoped>
.overview-list{
  display: flex;
  justify-content: space-around;
  padding: 24px 0 15px 0;
}

</style>